'use client';

import { FormEvent, ReactNode, useCallback } from 'react';

import { useReCaptcha } from 'next-recaptcha-v3';

export interface ReCaptchaFormOnSubmitProps {
  formData: FormData;
  reCaptchaState: { error: boolean; loaded: boolean };
}

export interface ReCaptchaFormProps {
  children: ReactNode;
  className?: string;
  onSubmit: (props: ReCaptchaFormOnSubmitProps) => void;
  reCaptchaActionName: string;
  id: string;
}

export function ReCaptchaForm({
  children,
  className,
  onSubmit,
  reCaptchaActionName,
  id,
}: ReCaptchaFormProps) {
  const { executeRecaptcha, error, loaded } = useReCaptcha();

  const handleFormSubmit = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      const formData = new FormData(event.currentTarget);

      const token = await executeRecaptcha(reCaptchaActionName);

      formData.append('recaptcha-token', token);

      onSubmit({ formData: formData, reCaptchaState: { error, loaded } });
    },
    [error, executeRecaptcha, loaded, onSubmit, reCaptchaActionName],
  );

  return (
    <form className={className} onSubmit={handleFormSubmit} id={id}>
      {children}
    </form>
  );
}
